// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3q1Nm","col":"CardReaderDesc_col__1oAN9","label":"CardReaderDesc_label__OiHND"};